import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Button
} from '@mui/material';
import { ViewKanban, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client/react';
import { BOARDS_LIST_QUERY, CREATE_OR_UPDATE_BOARD } from '../../graphql/boards';
import LoadingOverlay from '../common/LoadingOverlay';
import BoardModal from './BoardModal';

const BoardsList = () => {
  const navigate = useNavigate();
  const [newBoardDialogOpen, setNewBoardDialogOpen] = useState(false);
  const [selectedBoard, setSelectedBoard] = useState(null);

  const { data, loading, refetch } = useQuery(BOARDS_LIST_QUERY, {
    fetchPolicy: 'network-only'
  });

  const [createOrUpdateBoard] = useMutation(CREATE_OR_UPDATE_BOARD);

  const handleAddBoard = () => {
    setSelectedBoard(null);
    setNewBoardDialogOpen(true);
  };

  const handleEditBoard = (board, e) => {
    e.stopPropagation();
    setSelectedBoard(board);
    setNewBoardDialogOpen(true);
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('pl-PL');
  };



  if (loading) return <LoadingOverlay />;

  const boards = data?.boards || [];

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ViewKanban sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
          <Typography variant="h4" component="h1">
            Boards
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="success"
          startIcon={<Add />}
          onClick={handleAddBoard}
        >
          Create Board
        </Button>
      </Box>

      <Grid container spacing={3}>
        {boards.map((board) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={board.id}>
            <Card>
              <CardActionArea onClick={() => navigate(`/boards/${board.id}`)}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {board.name}
                  </Typography>
                  {(board.start_date || board.end_date) && (
                    <Box sx={{ mt: 1 }}>
                      {board.start_date && (
                        <Typography variant="body2" color="text.secondary">
                          Start: {formatDate(board.start_date)}
                        </Typography>
                      )}
                      {board.end_date && (
                        <Typography variant="body2" color="text.secondary">
                          End: {formatDate(board.end_date)}
                        </Typography>
                      )}
                    </Box>
                  )}
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      <BoardModal
        open={newBoardDialogOpen}
        onClose={() => {
          setNewBoardDialogOpen(false);
          setSelectedBoard(null);
        }}
        board={selectedBoard}
        onSave={async () => {
          await refetch();
        }}
      />
    </Box>
  );
};

export default BoardsList;
